import { render, staticRenderFns } from "./ReviewChanges.vue?vue&type=template&id=3d1eb7ca&scoped=true&"
import script from "./ReviewChanges.vue?vue&type=script&lang=js&"
export * from "./ReviewChanges.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChanges.vue?vue&type=style&index=0&id=3d1eb7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1eb7ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VDatePicker,VIcon,VMenu,VTextField})
